import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import _ from 'lodash';
import Box from '@amzn/meridian/box';
import Text from '@amzn/meridian/text';
import { useAppSelector } from 'src/store/store';
import { YesNoRestrictionTask } from 'src/utils/restrictionUtils';
import { setRestrictionListItems } from 'src/store/newJmrPageSlice/newJmrPageSlice';

/**
 * Display selector for "Yes/No" measurementType task.
 */
const YesNoRestrictionField = (props: { listIndex: number }) => {
  const { listIndex } = props;
  const dispatch = useDispatch();
  const { restrictionListItems } = useAppSelector((state) => state.newJmrPage);
  const task = restrictionListItems[listIndex] as YesNoRestrictionTask;

  // Only value for Yes/No should be 0
  useEffect(() => {
    const listNew = _.cloneDeep(restrictionListItems);
    (listNew[listIndex] as YesNoRestrictionTask).restrictedValue = 'No';
    dispatch(setRestrictionListItems(listNew));
  }, [task.taskId]);

  return (
    <Box spacingInset="200">
      <Text color="secondary" data-testid="new-jmr__yes-no-restriction-field-label">
        0 hrs (Associate cannot perform <b>{task?.label}</b>)
      </Text>
    </Box>
  );
};

export default YesNoRestrictionField;
